import { apiGET } from './api';

export const getFeatureFlags = () => apiGET('/feature_flags');
